import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import router from '@/router'
export default new Vuex.Store({
  state: {
    signInfo: {},
    userInfo: {},
    token: ''
  },
  mutations: {
    SETSIGNINFO (state, data) {
      state.signInfo = data
    },
    SETCODE (state, data) {
      state.code = data.code
    },
    SETUSERINFO (state, data) {
      state.userInfo = data
      // state.token = data.token
    }
  },
  actions: {
    setSignInfo ({commit}, data) {
      commit('SETSIGNINFO', data)
    },
    setCode ({commit}, data) {
      commit('SETCODE', data)
    },
    setUserInfo ({commit}, data) {
      commit('SETUSERINFO', data)
      localStorage.setItem('token', data.token)
      localStorage.setItem('isLogin', 1)
      localStorage.setItem('webOIUser', data.username)
    },
    loginOut ({commit}) {
      commit('SETUSERINFO', {})
      localStorage.removeItem('token')
      localStorage.removeItem('webOIUser')
      localStorage.removeItem('isLogin')

      router.push('/login')
    }
  },
  modules: {
  }
})
